import { render, staticRenderFns } from "./BookSessionByPackagesModal.vue?vue&type=template&id=67bee149&scoped=true"
import script from "./BookSessionByPackagesModal.vue?vue&type=script&lang=js"
export * from "./BookSessionByPackagesModal.vue?vue&type=script&lang=js"
import style0 from "./BookSessionByPackagesModal.vue?vue&type=style&index=0&id=67bee149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bee149",
  null
  
)

export default component.exports